var map = {
	"./Dashboard.vue": [
		"7277",
		"chunk-16ca4934"
	],
	"./Exercise.vue": [
		"652e",
		"chunk-2d0cfa68"
	],
	"./Video.vue": [
		"81a8",
		"chunk-2d0dd9a6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;